import React, { FC } from "react";
import { Link } from "react-router-dom";
import {
  IoChevronForward,
  IoCubeOutline,
  IoFlashOutline,
  IoPhonePortraitOutline,
} from "react-icons/io5";
import { Product } from "../../Shopping/Prodcuts";
import { RESEARCH } from "../../../data/research";
import "./StarterKitHero.css";

interface Props {
  product: Product;
  others?: Product[];
}

const HIGHLIGHTS = [
  { Icon: IoPhonePortraitOutline, label: "Phone-based motion feedback" },
  { Icon: IoCubeOutline, label: "Printed accessories for drills" },
  { Icon: IoFlashOutline, label: "Quick start in the app" },
];

export const StarterKitHero: FC<Props> = ({ product, others = [] }) => {
  // Hide: Price and Cart
  // const detailHref = `/shopping/info?id=${product.id}`;

  return (
    <>
      <section className="ui-hero-panel ui-hero-panel--split starter-kit" aria-labelledby="starter-kit-title">
        <div className="ui-hero-copy starter-kit-copy">
          <span className="ui-section-label">Starter kit</span>
          <h1 id="starter-kit-title">{product.name}</h1>
          <p className="starter-kit-desc">{product.description}</p>
          <p className="starter-kit-footnote">
            {RESEARCH.shopTeaser}{" "}
            <Link to="/research" className="ui-link research-text-link">
              See the results.
            </Link>
          </p>

          {/* Hide: Price and Cart */}
          {/* <div className="starter-kit-price">
            <span className="ui-stat-value starter-kit-price-value">
              ${product.price.toFixed(2)}
            </span>
            <span className="ui-section-label">Per kit, USD</span>
            <span className="ui-stat-sub">Taxes and shipping at checkout</span>
          </div> */}

          <ul className="starter-kit-highlights" aria-label="What's included">
            {HIGHLIGHTS.map(({ Icon, label }) => (
              <li key={label}>
                <span className="ui-icon-chip" aria-hidden>
                  <Icon aria-hidden />
                </span>
                <span>{label}</span>
              </li>
            ))}
          </ul>

          {/* Hide: Price and Cart */}
          {/* <Link to={detailHref} className="ui-btn ui-btn--inverted">
            View details and add to cart
          </Link> */}

          <p className="starter-kit-footnote">
            Fulfillment timing depends on your order and region and is
            confirmed at checkout or by email. Questions about fit or bulk
            orders?{" "}
            <Link to="/contact" className="ui-link">
              Contact us
            </Link>
            .
          </p>
        </div>
        <div className="ui-hero-media">
          <img src={product.image_paths[0]} alt={product.name} loading="eager" fetchPriority="high" />
        </div>
      </section>

      {others.length > 0 ? (
        <div className="ui-card starter-kit-others">
          <div className="starter-kit-others-header">
            <h3>Add-ons</h3>
            <p>Optional accessories for varied practice.</p>
          </div>
          <ul className="ui-list">
            {others.map((p) => (
              <li key={p.id}>
                <Link to={`/shopping/info?id=${p.id}`} className="ui-list-row">
                  <span className="ui-media ui-media--square starter-kit-other-thumb">
                    <img src={p.image_paths[0]} alt="" loading="lazy" decoding="async" />
                  </span>
                  <span className="ui-list-text">
                    <span className="ui-list-label">{p.name}</span>
                    {/* Hide: Price and Cart */}
                    {/* <span className="ui-list-desc">${p.price.toFixed(2)}</span> */}
                  </span>
                  <span className="ui-list-trailing">
                    <IoChevronForward aria-hidden />
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </>
  );
};
